export default {
  KNOW: 1,
  REVIEW: 2,
  CLUELESS: 3,
  properties: {
    1: { label: 'Know', value: 1, code: 'KNOW' },
    2: { label: 'Review', value: 2, code: 'REVIEW' },
    3: { label: 'Clueless', value: 3, code: 'CLUELESS' }
  }
}



// WEBPACK FOOTER //
// ./src/lib/StudyNeed.js